import { render, staticRenderFns } from "./WorkingDaysPtaxView.vue?vue&type=template&id=39d4b724"
import script from "./WorkingDaysPtaxView.vue?vue&type=script&lang=js"
export * from "./WorkingDaysPtaxView.vue?vue&type=script&lang=js"
import style0 from "./WorkingDaysPtaxView.vue?vue&type=style&index=0&id=39d4b724&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports